const truncate = (string: string, size: number): string => {
  if (string.length > size) {
    return string.substring(0, size) + "..."
  } else {
    return string
  }
}

export default truncate
